module.exports = __webpack_public_path__ + "static/img/zzs.38e5fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yanzi/zzs.png
// module id = Qdff
// module chunks = 1